var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.alert}},[_vm._v(" Launch Success Toast ")])}
var staticRenderFns = []

export { render, staticRenderFns }